import React, { Fragment } from 'react'
import { useAbout, AboutProps } from './useAbout'
import { Link } from 'react-router-dom'
import styles from './About.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'
import blockContentToHtml from '@sanity/block-content-to-html'

const About: React.FC<AboutProps> = (props: AboutProps) => {
  const { isAr, homeAbout, selectedLanguage, t } = useAbout(props)

  return homeAbout && homeAbout.length ? (
    <section id='about' className={styles.about}>
      <TitleSection title={t('navAboutUs')} />
      <div className='container'>
        <div className='row align-items-center'>
          {homeAbout[0].photoGallery &&
          homeAbout[0].photoGallery.length >= 3 ? (
            <div className='col-lg-6 mb-4 mb-lg-0'>
              <div className={styles['about-images']}>
                <img
                  src={homeAbout[0].photoGallery[0]}
                  alt='about 1'
                  className={`img-fluid rounded ${styles['img-1']}`}
                />
                <img
                  src={homeAbout[0].photoGallery[1]}
                  alt='about 2'
                  className={`img-fluid rounded ${styles['img-2']}`}
                />
                <img
                  src={homeAbout[0].photoGallery[2]}
                  alt='about 3'
                  className={`img-fluid rounded ${styles['img-3']}`}
                />
              </div>
            </div>
          ) : (
            <Fragment />
          )}

          <div className='col-lg-6'>
            <div className={styles['about-content']}>
              <h2>{isAr ? homeAbout[0].titleAr : homeAbout[0].titleEn}</h2>
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{
                  __html: isAr
                    ? Array.isArray(homeAbout[0].descriptionAr)
                      ? blockContentToHtml({
                          blocks: homeAbout[0].descriptionAr,
                        })
                      : `<p>${homeAbout[0].descriptionAr}</p>`
                    : Array.isArray(homeAbout[0].descriptionEn)
                      ? blockContentToHtml({
                          blocks: homeAbout[0].descriptionEn,
                        })
                      : `<p>${homeAbout[0].descriptionEn}</p>`,
                }}
              ></div>
            </div>
            <div className='d-flex justify-content-center justify-content-lg-start mb-4 mb-lg-0'>
              <Link
                to={`/${selectedLanguage}/Contact`}
                className='btn btn-secondary px-5 py-2'
              >
                {t('navContactUs')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <Fragment />
  )
}

export default About
